import {
  MasonryActionHandlerReturn,
  MasonryActionResult,
} from '#types/masonry-engine-action.types.ts';
import {
  MasonryEngineNodeAction,
  ActionResultData,
} from '#types/masonry-engine-node.types.ts';

const isMasonryActionResult = (value: unknown): value is MasonryActionResult =>
  typeof value === 'object' && value !== null && 'isSuccess' in value;

export const withNormalization = <Action extends MasonryEngineNodeAction>(
  invokeHandler: () => MasonryActionHandlerReturn<Action>,
): Promise<MasonryActionResult<ActionResultData<Action>>> => {
  try {
    return Promise.resolve(invokeHandler()).then((awaitedHandlerReturn) => {
      // Handle explicit MasonryActionResult objects
      if (isMasonryActionResult(awaitedHandlerReturn)) {
        return awaitedHandlerReturn as MasonryActionResult<
          ActionResultData<Action>
        >;
      }

      // Handle void/undefined as success
      if (awaitedHandlerReturn === undefined || awaitedHandlerReturn === null) {
        return { isSuccess: true };
      }

      // Handle any other case as success, and use the value as the `data` property
      // of the result object
      return {
        isSuccess: true,
        data: awaitedHandlerReturn as ActionResultData<Action>,
      };
    });
  } catch (error) {
    return Promise.reject(error);
  }
};
